export function removeStaticLoader() {
  const el = document.getElementById("staticloader");
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export function getAppBaseUrl() {
  const base = getAppBasePath();
  return `https://${window.location.host}${base ? base : ""}`;
}

export function getAppBasePath() {
  return process.env.PUBLIC_URL;
}

export function adjustToAndroidKeyboard() {
  // https://stackoverflow.com/questions/52384678/how-to-stop-soft-keyboard-resizing-chrome-browser-window-on-android-mobiles

  const viewport = document.querySelector("meta[name=viewport]");

  const adjustViewport = () => {
    viewport?.setAttribute(
      "content",
      "height=" +
        window.screen.height +
        "px, width=device-width, initial-scale=1.0"
    );
  };

  const resetViewport = () => {
    viewport?.setAttribute("content", "width=device-width, initial-scale=1.0");
  };

  window.addEventListener("resize", () => {
    const activeElementName = document.activeElement?.nodeName.toLowerCase();
    if (activeElementName === "textarea" || activeElementName === "input") {
      adjustViewport();
    } else {
      resetViewport();
    }
  });
}
